// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_LWkYv","icon":"index_icon_gAxVg","dropdownGray":"index_dropdownGray_HKvCp","dropdownDark":"index_dropdownDark_SLeoV","title":"index_title_wGdU2"};